/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * React Router 7.18 forwards the server nonce to generated style resources, but its
 * client FrameworkContext omits that nonce. Browsers redact a parsed nonce to an empty
 * content attribute, so React otherwise compares `nonce=""` with `undefined` and reports
 * a hydration mismatch. CSP has already evaluated these resources before this runs.
 */
export function normalizeReactRouterHydrationNonces(root: Document): void {
    root.querySelectorAll('link[nonce], style[nonce], script[type="application/ld+json"][nonce]').forEach((element) =>
        element.removeAttribute('nonce')
    );
}
